import Marionette from 'backbone.marionette';
import DialogService from 'base/dialog_service';
import GroupCreationView from 'base/views/create_group';
import MessageCreationView from 'names/views/message';
import NameService from 'names/service';
import qs from 'query-string';
import $ from 'jquery';
import _ from 'underscore';


let NamesDropdown = Marionette.LayoutView.extend({
    template: require('../templates/dropdown.html'),
    ui: {
        buttonClose: '.button-close',
        buttonCreateMessage: '.button-create-message',
        buttonCreateGroup: '.button-create-group'
    },
    triggers: {
        'click @ui.buttonClose': 'close',
        'click @ui.buttonCreateMessage': 'createMessage',
        'click @ui.buttonCreateGroup': 'createGroup'
    },
    
    onClose(){
        this.modal.close();
    },
    
    onCreateGroup(){
        this.modal.close();        
        NameService.createWithReport({
            report_name: this.getOption('report_name'),
            report_data: this.getOption('data')
        }, (uuid, count) => {
            DialogService.show(new GroupCreationView({
                orig: this.options.el,
                filter: uuid,
                contact_count: count,
            }));
        });
    },
    
    onCreateMessage(){
        this.modal.close();        
        NameService.createWithReport({
            report_name: this.getOption('report_name'),
            report_data: this.getOption('data')
        }, (uuid, count) => {
            DialogService.show(new MessageCreationView({
                orig: this.options.el,
                filter: uuid,
                contact_count: count,
            }));
        });
    }
});

let NamesWidget = Marionette.LayoutView.extend({
    template: require('../templates/button.html'),
    ui: {
        button: 'button'
    },
    triggers: {
        'click @ui.button': 'open'
    },
    onOpen(){
        let data = null;
        let el = $(this.el);
        const filter = this.getOption('filter');

        if(el.data('source-data') == '@GET'){
            data = qs.parse(location.search);
            data = _.omit(data, _.map(data, (val, k) => {
                if(val == ''){
                    return k;
                }
            }));
        } else{
            throw Error('Unknown data-source-data attribute value');
        }

        if (filter) {
            data.filter = filter.val();
        }
        
        let m = DialogService.show(new NamesDropdown({
            data,
            report_name: el.data('source')
        }));
        m.on('close', () => {
           m.close();
        });
    }
});

export default NamesWidget;



// WEBPACK FOOTER //
// ./names/views/widget.js